export default "__VITE_ASSET__2233cf5d__"